import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as GlowMarktIconSvg } from './theme/glowmarkt_icon.svg';
import Box from '@mui/material/Box';

export function GlowMarktIcon() {
  return (
    <SvgIcon sx={{ height: 30, width: 30, mr: 2 }}>
      <GlowMarktIconSvg />
    </SvgIcon>
  );
}

export function OctopusIcon() {
  return (
    <Box
      component="img"
      sx={{
        height: 40,
        width: 40,
        maxHeight: { xs: 40, md: 40 },
        maxWidth: { xs: 40, md: 40 },
        borderRadius: 40
      }}
      alt="Octopus Energy Logo"
      src="octopus_logo.png"
    />
  );
}